var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_76134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2818 45.12H-2.17285V0H62.2818V45.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2818 10.152H-2.17285V4.22998H62.2818V10.152ZM62.2818 41.0398H-2.17285V35.1178H62.2818V41.0398ZM19.7174 16.8054L29.42 33.6902L39.334 16.8847L19.7174 16.8142V16.8054Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5957 28.0061L29.4375 31.1345L31.3234 28.0237L27.5869 28.0061H27.5957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6826 28.2529L29.394 11.3682L39.2992 28.1824L19.6826 28.2529Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5954 16.8848L29.4372 13.7563L31.3231 16.876L27.5866 16.8848H27.5954ZM23.7356 23.8907L21.8232 27.0632L25.4364 27.0544L23.7356 23.8819V23.8907ZM21.8585 18.0304L25.4892 18.0568L23.7444 21.2558L21.8585 18.0304ZM35.183 23.9348L37.0248 27.0632L33.35 27.0192L35.183 23.9348ZM36.9896 18.0304L33.3588 18.0568L35.1037 21.2558L36.9896 18.0304ZM26.9169 18.0304L24.4141 22.56L26.9521 26.9927L31.6051 27.0985L34.4251 22.56L31.8166 17.9775L26.9169 18.0216V18.0304Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_76134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.1e71a2e41eeb89bdad5bbdb397d20780.svg";
export { ForwardRef as ReactComponent };